import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';
import AOS from 'aos';
import 'aos/dist/aos.css'
import Planes from './Planes';
import Redes from './Redes';

class Home extends React.Component {
    componentDidMount() {
        
        AOS.init({
        })
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Inicio">
                    <section className="row m-md-3 mr-0 ml-0" >
                        <div className="col-12 mb-2 px-3">
                            <div className="heroItmex">
                                <div className="heroItmex-content">
                                    <h1 className="heroItmex-title">Internet de fibra óptica<br/>en Hidalgo</h1>
                                    <p className="heroItmex-subtitle">
                                        Planes residenciales y empresariales con soporte técnico local.
                                    </p>
                                    <div className="heroItmex-actions">
                                        <a className="heroItmex-cta" href="#planesInternet">
                                            Ver planes
                                            <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                        </a>
                                        <Link className="heroItmex-cta-secondary" to="/cobertura">Consultar cobertura</Link>
                                    </div>
                                </div>
                                <div className="heroItmex-art">
                                    <img src="/assets/img/backgrounds/ixmiquilpan-main.jpg" alt="Fuente de la Diana Cazadora en Ixmiquilpan, Hidalgo" />
                                </div>
                                <div className="heroItmex-social">
                                    <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/itmexoficial" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                                    <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/reditmex/" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                                    <a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/channel/UC6Sirelw0bYpaT4VktsK19A" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
                                    <a rel="noopener noreferrer" target="_blank" href="https://open.spotify.com/show/56dQAu73j4a0QaLRO44oa7" aria-label="Spotify"><i className="fab fa-spotify"></i></a>
                                    <a rel="noopener noreferrer" target="_blank" href="https://podcasts.apple.com/mx/podcast/internet-en-pandemia/id1552637394" aria-label="Apple Podcasts"><i className="fas fa-podcast"></i></a>
                                    <a rel="noopener noreferrer" target="_blank" href="https://wa.me/5217712438160?text=Hola%2C+%C2%BFme+podr%C3%ADas+brindar+informaci%C3%B3n+del+servicio+de+internet%3F+%F0%9F%91%A8%F0%9F%8F%BB%E2%80%8D%F0%9F%92%BB" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Planes />
                    <hr style={{border: '1px solid rgb(100,100,100,.1)'}}/>
                    <Redes />
                </ Layout>
            </div >

        )
    }
};

export default Home;
